import { v4 as uuid } from "uuid";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { getData, getDataById, insertData } from "../../utils/fetch";

import css from "./index.module.css";
import Button from "@mui/material/Button";
import Input from "../../components/Input";
import Header from "../../components/Header";
import AddIcon from "@mui/icons-material/Add";
import Loading from "../../components/Loading";
import SchoolIcon from "@mui/icons-material/School";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

/**
 * Start-page for a teacher after logging in. Displays available classes
 */
const Teacher = ({teacherId}) => {
  const [data, setData] = useState([]);
  const [classes, setClasses] = useState([]);
  const [teacherToClasses, setTeacherToClasses] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    
    getDataById("/api/teacherToClasses/byId", {teacherId: teacherId ? teacherId : ""}).then(data => {
      setTeacherToClasses(data);
      getData("/api/classes").then(data => {
        setClasses(data);
      });
    });
    
    
  }, [teacherId]);

  useEffect(() => {
    const temp = [];
    classes?.forEach(c => {
      teacherToClasses?.forEach(ttc => {
        if(c.id === ttc.class_id){
          temp.push(c);
        }
      })
    })
    setData(temp);
  }, [classes, teacherToClasses, ])

  return (
    <div className={css.page}>
      <Header isTeacher={true} nav="Klassen" />
      {classes !== null && classes.length === 0 && (
        <p style={{ color: "red" }}>Fehler: {error}</p>
      )}
      <div className={css.container}>
        <NewClass setClasses={setClasses} setTeacherToClasses={setTeacherToClasses} teacherId={teacherId}/>
        {data == null && <Loading />}
        {data.length > 0 ? (
            data?.map((cls) => <Class key={"class_" + cls.id} data={cls} teacherId={teacherId} />)
          ) : (
            <p>Keine Klassen gefunden.</p>
        )}
      </div>
    </div>
  );
};

/**
 * Renders a single class with its name. Redirects to given classpage when clicked 
 * @param {Object} data of the given Class 
 * @returns 
 */
const Class = ({ data, teacherId }) => {
  return (
    <div key={data.id} className={css.classCard}>
      <SchoolIcon style={{ fontSize: 50 }} />
      <div className={css.title}>
        <span>Klasse</span>
        <span>{data.name}</span>
      </div>
      <Link to={`/teacher/${teacherId}/class/${data.id}`}>
        <ArrowForwardIosIcon style={{ fontSize: 50 }}/>
      </Link>
    </div>
  );
};

/**
* Renders a new class field to add to the db 
 * @param {Function} setClasses Updates classlist
 */
const NewClass = ({ setClasses, setTeacherToClasses, teacherId }) => {

  const [error, setError] = useState(false);

  //returns a random 6 character string
  const generateClassCode = () => {
    return Math.random().toString(36).substring(2, 8).toUpperCase();
  };

  const createClass = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const name = formData.get("name");
    document.getElementById("name").value = "";
    if(name === ""){
      setError(true)
      return
    }
    const newUuid = uuid();

    insertData("/api/classes", {
        id: newUuid,
        name: name,
        classcode: generateClassCode(),
        grade: 0
      } ).then(() => {
        insertData("/api/teacherToClasses", {
        teacherId: teacherId,
        classId: newUuid 
      }).then(() => {
        getDataById("/api/teacherToClasses/byId", {teacherId: teacherId}).then(data => {
      setTeacherToClasses(data);
      getData("/api/classes").then(data => {
        setClasses(data);
      });
    })
      })
      })
  }
        
        
      

  return (
    <form className={css.classCard} onSubmit={createClass}>
      <SchoolIcon style={{ fontSize: 50 }} />
      <div className={css.title}>
        <span>Neue Klasse</span>
        <div className={css.inputerror}>
          <Input type="text" placeholder="Klassenname" id="name" name="name" onChange={() => setError(false)}/>
          {error && <PriorityHighIcon />}
        </div>
        
      </div>
      <Button type="submit">
        <AddIcon style={{ fontSize: 50 }} />
      </Button>
    </form>
  );
};

export default Teacher;
